import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UploadEvent, UploadFile, FileSystemFileEntry } from 'ngx-file-drop';

import { AuthService } from '../../services/auth.service';
import { CommonService } from '../../services/common.service';
import { CompanyService } from '../../services/company.service';
import { JobService } from '../../services/job.service';

import { ICompanyContactLogin } from '../../models/ICompanyContactLogin.model';
import { ICompensation } from '../../models/ICompensation.model';
import { ICompensationType } from '../../models/ICompensationType.model';
import { IJobAdd } from '../../models/IJobAdd.model';
import { IPositionType } from '../../models/IPositionType.model';
import { User } from '../../models/User.model';



@Component({
    selector: 'app-add-job',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.less']
})
export class JobAddComponent implements OnInit {
    private contact: ICompanyContactLogin;

    user: User;
    job: IJobAdd = new IJobAdd;
    descriptionType: string;
    enterDescription: string;
    positionTypes: IPositionType[];
    compensationTypes: ICompensationType[];

    compensations: ICompensation[] = [{
        CompensationId: 0,
        CompensationTypeId: 0,
        Description: 'Unspecified',
        Value: 0
    }];

    compensationsTo: ICompensation[] = this.compensations;
    jobDescriptionFile: string;
    fileSelected: boolean;
    files: UploadFile[] = [];
    validFileType = true;
    fileRemoved: boolean;
    hasSalaries = false;
    impersonating = false;

    @ViewChild('addJobForm') form: any;

    constructor(
        private _auth: AuthService,
        private _common: CommonService,
        private _company: CompanyService,
        private _job: JobService,
        private _router: Router
    ) {
        this.user = _auth.getUser();
    }

    onHireTypeChange(): void {
        this._common.getCompensationTypes(this.job.PositionTypeId)
            .subscribe(result => {
                this.compensationTypes = result;
            });
    }

    onPayTypeChange(): void {
        this._common.getCompensations(this.job.CompensationTypeId)
            .subscribe(result => {
                this.compensations = this.compensationsTo = result;
                this.hasSalaries = result.length > 0;
            });
    }

    updateFromCompensation(): void {
        this.job.CompensationFrom = this.compensations.find(x => +x.CompensationId === +this.job.CompensationFromId).Value;

        let index = 0;

        for (index; index < this.compensations.length; index++) {
            if (+this.compensations[index].CompensationId === +this.job.CompensationFromId) {
                break;
            }
        }

        this.compensationsTo = this.compensations.slice(index);
    }

    updateToCompensation(): void {
        this.job.CompensationTo = this.compensations.find(x => +x.CompensationId === +this.job.CompensationToId).Value;
    }

    cancel(): void {
        this.job = new IJobAdd;
        this.form.form.markAsPristine();
    }

    addJob(): void {
        if (this.form.invalid) {
            return;
        }

        this.job.CompanyId = this.contact.CompanyId;
        this.job.CompanyContactId = this.contact.CompanyContactId;
        this.job.SysUserId = this.contact.SysUserId;
        this.job.IsAdmin = this.contact.IsAdmin;

        this._job.submitJob(this.job)
            .then((result) => {
                this._router.navigate(['/jobs'], { queryParams: { i: true } });
            });
    }

    fileChanged(event): void {
        this.jobDescriptionFile = event.target.files[0].name;
        this.checkFileType(this.jobDescriptionFile);
        this.fileSelected = true;
        this.fileRemoved = false;
        this.job.JobDescriptionFile = event.target.files[0];
    }

    clearFile(): void {
        this.jobDescriptionFile = '';
        this.fileSelected = false;
        this.fileRemoved = true;
    }

    dropped(event: UploadEvent): void {
        this.files = event.files;
        this.jobDescriptionFile = this.files[0].relativePath;
        this.fileSelected = true;
        this.fileRemoved = false;
        this.checkFileType(this.jobDescriptionFile);
        if (this.files[0].fileEntry.isFile && this.validFileType) {
            const fileEntry = this.files[0].fileEntry as FileSystemFileEntry;
            fileEntry.file((file: File) => {
                this.job.JobDescriptionFile = (this.files[0].relativePath.toString(), file);
            });
        }
    }

    checkFileType(fileName): void {
        const allowTypes = ['doc', 'txt', 'docx', 'pdf', 'html', 'rtf'];
        const fileType = fileName.substring(fileName.lastIndexOf('.') + 1);
        if (allowTypes.indexOf(fileType) === -1) {
            this.validFileType = false;
        } else {
            this.validFileType = true;
        }
    }

    setDescriptionType() {
        this.descriptionType = 'enter';
    }

    ngOnInit() {
        this.descriptionType = 'upload';
        this.impersonating = this._auth.getImpersonationData() != null;
        this.contact = this._company.getLoginInfo();

        this._common.getPositionTypes()
            .subscribe(result => {
                this.positionTypes = result;
            });

        this.fileSelected = false;

        this.job.CompensationFromId = null;
        this.job.CompensationFrom = null;
        this.job.CompensationToId = null;
        this.job.CompensationTo = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/job/add.component.ts